import { render, staticRenderFns } from "./Showcase.vue?vue&type=template&id=85825a00&"
import script from "./Showcase.vue?vue&type=script&lang=js&"
export * from "./Showcase.vue?vue&type=script&lang=js&"
import style0 from "./Showcase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports